import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type AudiCalculationModuleUpdateSettings } from '../../../../api/types';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import AudiCalculationModuleUpdateForm from './AudiCalculationModuleUpdateForm';

type AudiCalculationModuleUpdateDrawerProps = {
    moduleId: string;
    initialValues: AudiCalculationModuleUpdateSettings;
    visible: boolean;
    onClose: () => void;
};

const AudiCalculationModuleUpdateDrawer = ({
    moduleId,
    initialValues,
    visible,
    onClose,
}: AudiCalculationModuleUpdateDrawerProps) => {
    const { t } = useTranslation(['audiCalculationModuleDetails']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('audiCalculationModuleDetails:actions.cancel')}</Button>
                    <Button form="updateAudiCalculationModule" htmlType="submit" type="primary">
                        {t('audiCalculationModuleDetails:actions.update')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('audiCalculationModuleDetails:mainActionButtons.updateSpecs')}
            visible={visible}
            destroyOnClose
        >
            <AudiCalculationModuleUpdateForm initialValues={initialValues} moduleId={moduleId} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default AudiCalculationModuleUpdateDrawer;

export const useAudiCalculationModuleUpdateDrawer = (
    moduleId: string,
    initialValues: AudiCalculationModuleUpdateDrawerProps['initialValues']
) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => (
            <AudiCalculationModuleUpdateDrawer
                initialValues={initialValues}
                moduleId={moduleId}
                onClose={actions.close}
                visible={visible}
            />
        ),
    };
};
